import { z } from "zod";
import "../classes/datatypes";
function transformData(data) {
  return {
    ...data,
    chapitres: data.chapitres.map((chapitre) => {
      return {
        ...chapitre,
        occupancy: {
          max: chapitre.maxPeople,
          current: chapitre.totalPeople,
          onWaitlist: chapitre.totalWaitlist
        }
      }
    }),
    buslines: data.buslines.map((line) => {
      return {
        name: line.name,
        country: { code: line.country },
        stops: line.stops.map((stop) => {
          return {
            ...stop,
            PlaceDetails: stop.Place
          };
        }),
        oneWayOccupancy: {
          max: line.maxSeats,
          current: line.totalOneway,
          onWaitlist: line.totalOnewayWaitList
        },
        returnOccupancy: {
          max: line.maxSeats,
          current: line.totalReturn,
          onWaitlist: line.totalReturnWaitList
        },
        currency: line.currency,
        priceRules: line.prices.map((p) => {
          return {
            ...p,
            ageMax: p.AgeMax,
            priceOneWay: p.PriceOneWay,
            priceRoundTrip: p.PriceRoundTrip,
            priceNoTrip: p.PriceNoTrip
          };
        })
      }
    }),
  }

}


const countrySchema = z.object({
  code: z.string(),
  //name: z.string(),
});

const busStopDataSchema = z.object({
  PlaceDetails: z.string(),
  Title: z.string(),
});

const occupancySchema = z.object({
  max: z.number(),
  current: z.number(),
  onWaitlist: z.number(),
});

const priceRuleSchema = z.object({
  ageMax: z.number(),
  priceOneWay: z.number(),
  priceRoundTrip: z.number(),
  priceNoTrip: z.number(),
  dateMax: z.coerce.date(),
});

const buslineDataSchema = z.object({
  stops: z.array(busStopDataSchema),
  name: z.string(),
  country: countrySchema,
  currency: z.string().refine((value) => value === "CHF" || value === "€"),
  priceRules: z.array(priceRuleSchema),
  oneWayOccupancy: occupancySchema,
  returnOccupancy: occupancySchema,
});

const chapitreDataSchema = z.object({
  chapitreId: z.number(),
  name: z.string(),
  ageMin: z.number(),
  maxPeople: z.number().nullable(),
  totalPeople: z.number(),
  totalWaitlist: z.number(),
  regions: z.array(z.string()),
  occupancy: occupancySchema,
});

const responseSchema = z.object(
  {
    "buslines": z.array(buslineDataSchema),
    "chapitres": z.array(chapitreDataSchema),
  }
);

type FetchDataResponse = z.infer<typeof responseSchema>;

const fetchDataSync = (): FetchDataResponse | null => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', './backend/form_data.php', false); // false pour requête synchrone
  try {
    xhr.send();
    if (xhr.status === 200) {
      console.log(transformData(JSON.parse(xhr.responseText).data));
      const parsed = responseSchema.safeParse(transformData(JSON.parse(xhr.responseText).data));
      if (!parsed.success) {
        throw new Error("Invalid response payload shape");
      }
      return parsed.data;
    } else {
      throw new Error(`HTTP error! status: ${xhr.status}`);
    }
  } catch (error) {
    console.error('Error fetching JSON data:', error);
    return null;
  }
};
export default fetchDataSync;
